import styled from "@emotion/styled";

export const Wrapper = styled.div`
  --FieldWrapper-gap: 20px;
`;
